import { Button, Col, Input, Row } from "antd";
import { enterKeyHandler } from "../../../_utils/keyboard_events";

export default function Search({ hook, changePanel }){

    const search = () => {
        changePanel();
        hook.loadData();
    }

    return(
        <Row>
            <Col lg={24} xs={24}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <span style={{ fontSize: '1.8em', fontWeight: 'bold', margin: '20px 0px' }}>CINTALAST SAS</span>
                    <Input
                        style={{ width: '300px', margin: '20px 0px' }}
                        value={ hook.filter.search }
                        onChange={(e) => {
                            hook.changeSearch(e.target.value ? e.target.value.toUpperCase() : '');
                        }}
                        onKeyUp={(e) => {
                            enterKeyHandler(e, () => {
                                search();
                            });
                        }}  
                    />
                    <Button
                        type="primary"
                        onClick={() => {
                            search();
                        }}
                    >
                        Buscar
                    </Button>
                </div>
            </Col>
        </Row>
    );
}